import { Controller } from "stimulus";
import EmblaCarousel from "embla-carousel";

export default class extends Controller {
  connect() {
    const prevBtn = this.element.querySelector(".embla__prev");
    const nextBtn = this.element.querySelector(".embla__next");
    if (!prevBtn || !nextBtn) return;

    const addTogglePrevNextBtnsActive = (emblaApi) => {
      const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) {
          prevBtn.classList.remove("embla__button--disabled");
        } else {
          prevBtn.classList.add("embla__button--disabled");
        }

        if (emblaApi.canScrollNext()) {
          nextBtn.classList.remove("embla__button--disabled");
        } else {
          nextBtn.classList.add("embla__button--disabled");
        }
      };

      togglePrevNextBtnsState();

      emblaApi
        .on("select", togglePrevNextBtnsState)
        .on("reInit", togglePrevNextBtnsState);
    };

    const scrollPrev = () => this.embla.scrollPrev();
    const scrollNext = () => this.embla.scrollNext();

    prevBtn.addEventListener("click", scrollPrev);
    nextBtn.addEventListener("click", scrollNext);

    const options = {
      active: true,
      loop: true,
    };

    this.embla = EmblaCarousel(this.element, options);
    addTogglePrevNextBtnsActive(this.embla);

    this._scrollPrev = scrollPrev;
    this._scrollNext = scrollNext;
  }

  disconnect() {
    const prevBtn = this.element.querySelector(".embla__prev");
    const nextBtn = this.element.querySelector(".embla__next");

    if (prevBtn && this._scrollPrev) {
      prevBtn.removeEventListener("click", this._scrollPrev);
    }
    if (nextBtn && this._scrollNext) {
      nextBtn.removeEventListener("click", this._scrollNext);
    }

    this.embla?.destroy();
    this.embla = null;
  }
}
